module.exports = __webpack_public_path__ + "static/media/Your-Name_Client-Name_Project-Title_Invoice-Date.74fb1a26.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/invoice/Your-Name_Client-Name_Project-Title_Invoice-Date.docx
// module id = 1822
// module chunks = 0